module.exports = __webpack_public_path__ + "img/Cardiologue.9dbf7e75.png";